import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import { Dock } from '../../../components/common'
import styles from '../chat.style'
import cssStyles from '../chat.module.scss'
import { getText } from '../../../internal/TextLabels'

export const ChatQueueView = props => {
  return (
    <Dock
      title={props.title}
      closeText={getText('default.close')}
      onBack={props.onClose}
      onMinimize={props.onMinimize}
      dockClass={cssStyles.dock}
    >
      <div className={midas.textCenter}>
        <span>{getText('chat.queue.position')}</span>
        <br />
        <span style={styles.queuePos}>{props.queuePos}</span>
        <br />
        <hr />
        {props.estQueueTime && (
          <span>
            {getText('chat.queue.estTime')} {props.estQueueTime}{' '}
            {getText('chat.queue.timeUnit')}
          </span>
        )}
      </div>
    </Dock>
  )
}

ChatQueueView.propTypes = {
  title: PropTypes.string.isRequired,
  queuePos: PropTypes.number.isRequired,
  estQueueTime: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onMinimize: PropTypes.func.isRequired,
}

ChatQueueView.defaultProps = {
  estQueueTime: null,
}
